import { FC, useState, useEffect } from "react";
import {
  transformDate,
  tablePagination,
  searchTableData,
  sortTableValues,
} from "../../../Utility/Utility";
import ViewHeader from "../../../components/ViewHeader/ViewHeader";
import Button from "../../../components/UI/Button/Button";
import TableHeaderComponent from "../../../components/TableHeader/TableHeader";
import TableFooter from "../../../components/TableFooter/TableFooter";
import EmptyTableView from "../../../components/EmptyTableView/EmptyTableView";

import { RootState } from "../../../app/Store";
import { useSelector, useDispatch } from "react-redux";
import { addMoneyToUserWallet, disableEnableUser, getUserAmount, getUserList } from "../../../features/Users";
import JsonToCsv from "../../../components/JSONToCSV/JsonToCsv";

import {
  Wrapper,
  Container,
  ModalWrapper,
  InputSection,
  ModalMessege,
  ModalFrom,
  UserBalance,
  ModalData,
  ModalBtn,
} from "./StyledUserList";
import * as TableStyle from "../../Lottery/LotteryList/StyledLottery";

import { useNavigate } from "react-router-dom";
import { adminRouts } from "../../../routs";
import useDimension from "../../../costomHook/useDimention";
import Modal from "../../../components/Modal/Modal";
import { TextField } from "@mui/material";
import ActionModal from "../../../components/Modal/ActionModal";

enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
  danger = "danger",
  dangerOutline = "dangerOutline",
}

class TableHeader {
  constructor(
    public label: string,
    public isSortRequired: boolean,
    public isAscSorted: boolean,
    public isDscSorted: boolean,
    public id: string
  ) {}
}

let tableHeaders = [
  new TableHeader("User ID", true, true, false, "userId"),
  new TableHeader("Email ID", false, true, false, "emailId"),
  new TableHeader("User Name", false, false, false, "userName"),
  new TableHeader("Mobile No", false, false, false, "mobileNo"),
  new TableHeader("Godld Member", false, false, false, "isGoldMember"),
  new TableHeader("Gender", false, false, false, "gender"),
  new TableHeader("City", false, false, false, "city"),
  // new TableHeader("State", false, false, false, "state"),
  new TableHeader("Country", false, false, false, "country"),
  new TableHeader("Is 2FA", false, false, false, "using2FA"),
  new TableHeader("Wallet", false, false, false, "state"),

  // new TableHeader("Action", false, false, false, 'action')
];

let tabMenuViewList = [
  {
    label: "All",
    id: "winnerAuctions_2",
    queryParam: "C",
    isActive: true,
    isSerarchViewActive: false,
  },
  // {
  //   label: "Active",
  //   id: "activeUser",
  //   queryParam: "C",
  //   isActive: false,
  //   isSerarchViewActive: false,
  // },
  // {
  //   label: "InActive",
  //   id: "InactiveUser",
  //   queryParam: "C",
  //   isActive: false,
  //   isSerarchViewActive: false,
  // },
  // {
  //     label: "Gold Members",
  //     id: "cancelledAuctions_3",
  //     queryParam:"U",
  //     isActive: false,
  //     isSerarchViewActive: false
  // },
  // {
  //     label: "Regular Members",
  //     id: "pendingAuctons_4",
  //     queryParam:"E",
  //     isActive: false,
  //     isSerarchViewActive: false
  // }
];

const UserList: FC = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const dimention = useDimension();
  const [tabMenu, setTabMenu] = useState(tabMenuViewList);
  const [tableHeaderValues, setHeaderValues] = useState(tableHeaders);
  const [originalResponse, setOriginalResponse] = useState<any>([]);
  const [responseData, setResponseData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalResponseLength, setResponseLength] = useState(0);
  const [tableSearch, setSearch] = useState("");
  const [editUserId, setEditUserId] = useState("");
  const [openEditModel, setOpenEditModel] = useState(false);
  const [openDisableModel, setOpenDisableModel] = useState(false);
  const [userId,setUserId]=useState("");
  const [amount, setAmount] = useState("");
  const [userBalance, setUserBalance] = useState(0);
  const [valid, setValid] = useState(false);
  const [active, setActive]=useState(false);
  const [publicUserid, setPublicUserId]=useState("");


  const userList = useSelector((state: RootState) => state.users.users);
  const userAmountList = useSelector((state: RootState) => state.users.userAmount);

  
  const redirectToDetailView = (userId: any) => {
    navigate(adminRouts.viewUser(userId));
  };
  useEffect(() => {
    if (userList.length === 0) {
      getTableData(tabMenu);
    }
    dispatch(getUserAmount());
  }, []);
console.log(userList)
  useEffect(() => {
    if (userList.length > 0) {
      setResponseLength(userList.length);
      setOriginalResponse(userList);
      let pagedResponse = tablePagination(userList, 1);
      if (pagedResponse.isValidResponse) {
        setResponseData(pagedResponse.data);
      }
    } else {
      setResponseData([]);
    }
  }, [userList]);

  

  const updateTabMenuOption = (selectedMenuId) => {
    let updatedMenuArray = tabMenu.map((menuObj) => {
      return {
        ...menuObj,
        isActive: menuObj.id === selectedMenuId,
      };
    });
    getTableData(updatedMenuArray);
    setTabMenu(updatedMenuArray);
  };

  const getTableData = (tabObj) => {
    let selectedObj = tabObj.filter((tabObj) => {
      return tabObj.isActive;
    })[0];

    if (userList.length === 0) {
      dispatch(getUserList(`auctionStatus=${selectedObj.queryParam}`));
    }
  };

  const updatePageNumber = (pageNumber) => {
    if (originalResponse.length > 0) {
      let pagedResponse = tablePagination(originalResponse, pageNumber);
      if (pagedResponse.isValidResponse) {
        setPageNumber(pagedResponse.pageNumber);
        setResponseData(pagedResponse.data);
      }
    }
  };

  let tabMenuView = tabMenu.map((menuObj) => {
    return (
      <TableStyle.MenuOption
        onClick={() => {
          updateTabMenuOption(menuObj.id);
        }}
        isActive={menuObj.isActive}
        key={menuObj.id}
      >
        {menuObj.label}
      </TableStyle.MenuOption>
    );
  });

  const sortTable = (id: string, isSortAsc: boolean) => {
    let sortedArray: any = sortTableValues(originalResponse, id, !isSortAsc);
    setPageNumber(1);
    setOriginalResponse(sortedArray);
    let pagedResponse = tablePagination(sortedArray, 1);
    setResponseData(pagedResponse.data);
    let updatedTableHeaders: any = [];
    for (let headerObj of tableHeaderValues) {
      if (headerObj.id === id) {
        let updatedObj = {
          ...headerObj,
          isAscSorted: !isSortAsc,
          isDscSorted: isSortAsc,
        };
        updatedTableHeaders.push(updatedObj);
      } else {
        let updatedObj = {
          ...headerObj,
          isAscSorted: false,
          isDscSorted: false,
        };
        updatedTableHeaders.push(updatedObj);
      }
    }
    setHeaderValues(updatedTableHeaders);
  };

  const setTableSearchValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const triggerSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      let searchResponse = searchTableData(originalResponse, tableSearch);
      if (searchResponse.length > 0) {
        setResponseData(searchResponse);
        setPageNumber(1);
        setResponseLength(searchResponse.length);
      }
    }
  };

  const disableEnableUserModalHandler = (id: string,isActive:boolean,publicUserId:any) => {
    // console.log(id)
    // dispatch(disableEnableUser(id));
    setOpenDisableModel(true);
    setUserId(id);
    setActive(isActive);
    setPublicUserId(publicUserId)
  };

  const disableEnableUserHandler = () => {
    // console.log(userId)
    dispatch(disableEnableUser({
      userId:userId,
        publicUserId:publicUserid
    }));
    setOpenDisableModel(false)
  };
  const editUserHandler = (id: string,publicUserId:string) => {
    console.log(publicUserId)
    setEditUserId(publicUserId);
    setOpenEditModel(true);

    userList.map((user) => {
      if (user.userId === id) {
        // console.log(user)
        setUserBalance(user.amount);
      }
    });
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    setAmount(event.target.value);
    setValid(false);
  };

  const editUserModalHandler = (
    event: React.ChangeEvent<HTMLFormElement>
  ): void => {
    event.preventDefault();
    if (!amount.trim()) {
      setValid(true);
      return;
    }
    // alert(amount);
    setOpenEditModel(false);
    dispatch(addMoneyToUserWallet({
      publicUserId:editUserId,
      amount:Number(amount)
  }))
    setAmount('');
  };

  let tableBody = responseData.map((tableRowObj: any) => {
    // console.log(tableRowObj)
    let idBtn = (
      <Button
        title={`#${tableRowObj.userId}`}
        btnSize={ButtonSize.sm}
        btnVariant={ButtonVariant.primaryLink}
        clicked={()=>redirectToDetailView(tableRowObj?.userId)}
      />
    );

    let amount = 0;
    userAmountList.map((obj:any)=>obj?.userId===tableRowObj?.userId ? amount= obj?.amount : null )
    let isActive = false;
    userAmountList.map((obj:any)=>obj?.userId===tableRowObj?.userId ? isActive= obj?.isActive : null )

    return (
      <tr>
        <td>{idBtn}</td>
        <td>{tableRowObj.emailId}</td>
        <td>{tableRowObj.firstName + " " + tableRowObj.lastName}</td>
        <td>{tableRowObj.mobileNo}</td>
        <td>{tableRowObj.isGoldMember ? "Yes" : "No"}</td>
        <td>{tableRowObj.gender}</td>
        <td>{tableRowObj.city}</td>
        {/* <td>{tableRowObj.state}</td> */}
        <td>{tableRowObj.country}</td>
        <td>{tableRowObj.using2FA === true ? "Yes" : "No"}</td>
        <td>{amount}</td>
        <td>
          {/* <div
            style={{ display: "flex", justifyContent: "center", gap: "5px" }}
          >
            <Button
              title={isActive ? "Disable" : "Enable"}
              btnSize={dimention.width <= 1021 ? ButtonSize.sm : ButtonSize.sm}
              btnVariant={
                isActive
                  ? ButtonVariant.dangerOutline
                  : ButtonVariant.secondary
              }
              // clicked={() => disableEnableUserHandler(tableRowObj.userId)}
              clicked={() => disableEnableUserModalHandler(tableRowObj.userId,isActive,tableRowObj.publicUserId)}
            />
            <Button
              title={" Edit "}
              btnSize={dimention.width <= 1021 ? ButtonSize.sm : ButtonSize.sm}
              btnVariant={ButtonVariant.danger}
              clicked={() => editUserHandler(tableRowObj.userId,tableRowObj.publicUserId)}
            />
          </div> */}
        </td>
      </tr>
    );
  });

  return (
    <Wrapper>
      <Container>
        <Modal
          isOpen={openEditModel}
          name={"Edit User Model"}
          title={"Edit User"}
          toggleModal={() => setOpenEditModel(false)}
        >
          <ModalWrapper>
            <ModalMessege>You can only update user wallet amount.</ModalMessege>
            <UserBalance>User Wallet Balance : {userBalance}</UserBalance>
            <ModalFrom>
              <form onSubmit={editUserModalHandler}>
                <InputSection>
                  <TextField
                    fullWidth={true}
                    id="outlined-basic"
                    label="add amount"
                    variant="outlined"
                    value={amount}
                    onChange={(e) => handleInputChange(e)}
                    // required={true}
                    error={valid}
                    helperText={valid && "Please enter amount."}
                  />
                  <div>
                    <Button
                      title={"Update"}
                      btnSize={ButtonSize.md}
                      btnVariant={ButtonVariant.danger}
                      clicked={() => {}}
                    />
                  </div>
                </InputSection>
              </form>
            </ModalFrom>
          </ModalWrapper>
        </Modal>

        <ActionModal confirm={disableEnableUserHandler} openModal={openDisableModel} title={active?"Disable":"Enable"} setOpenModal={setOpenDisableModel} content={"User"}/>
        

        <TableStyle.BreadcrumbSection>
          <ViewHeader title={"Users"} />
          <JsonToCsv data={userList} fileLabel={"users"} />
          
        </TableStyle.BreadcrumbSection>
      </Container>
      <TableStyle.ContentSection>
        <TableStyle.SearchSectionContainer>
          <TableStyle.Input
            value={tableSearch}
            onKeyDown={triggerSearch}
            onChange={setTableSearchValue}
            placeholder={"Search"}
          />
        </TableStyle.SearchSectionContainer>
        <TableStyle.TabMenuContainer>{tabMenuView}</TableStyle.TabMenuContainer>
        <TableStyle.TableWrapper>
          <TableStyle.Table>
            <TableHeaderComponent
              headers={tableHeaderValues}
              onToggleSort={sortTable}
            />

            <TableStyle.Tbody>{tableBody}</TableStyle.Tbody>
          </TableStyle.Table>
          {userList.length === 0 && <EmptyTableView />}
          <TableFooter
            totalCount={totalResponseLength}
            currentPageNumber={pageNumber}
            updatePageNumber={updatePageNumber}
          />
        </TableStyle.TableWrapper>
      </TableStyle.ContentSection>
    </Wrapper>
  );
};

export default UserList;
